import { render, staticRenderFns } from "./WF3_NewInquiry.vue?vue&type=template&id=bc17629e&scoped=true"
import script from "./WF3_NewInquiry.vue?vue&type=script&lang=js"
export * from "./WF3_NewInquiry.vue?vue&type=script&lang=js"
import style0 from "./WF3_NewInquiry.vue?vue&type=style&index=0&id=bc17629e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc17629e",
  null
  
)

export default component.exports